
export { GGUSection } from "/codebuild/output/src1614243332/src/packages/shared-components/src/campaign/GGUSection.tsx"